import React, { Component } from "react"
import styled from 'styled-components'
import get from 'lodash/get'
import { Nav, NavItem, NavLink } from 'reactstrap'
import Top from '../kawari-calendar/team-leave/top'
import { FONTS, COLORS } from '../../constants'
import SearchIcon from "../../static/images/search_icon.svg"
import "../../static/css/index.css"

export default class Searchbar extends Component {
  state={ tempSearch: '' }

  render() {
    return (
      <Wrapper>
        <NavbarTab tabs>
          <NavItem>
            <NavLinkTab
              style={ { color: get(this.props, 'activeTab') === '1' ? COLORS.PRIMARY_RED : '',
                borderBottom: get(this.props, 'activeTab') === '1' ? `4px solid ${COLORS.PRIMARY_RED}` : '',
                borderTopStyle: 'none',
                borderLeftStyle: 'none',
                borderRightStyle: 'none',
              } }
              onClick={ () => { get(this.props, 'toggle')('1') } }
            >
          LOB Calendar
            </NavLinkTab>
          </NavItem>
          <NavItem>
            <SearchField
              placeholder='Search by name'
              onChange={ (e) => {
                if (e.target.value === '') get(this.props, 'handleSearch')(e.target.value)
                this.setState({ tempSearch: e.target.value })
              } }
              onKeyDown={ (e) => {
                if (e.keyCode === 13) get(this.props, 'handleSearch')(this.state.tempSearch)
              } }
            />
          </NavItem>
        </NavbarTab>
        { get(this.props, 'activeTab') === '1' &&
          <TeamLeaveTop>
            <Top
              data={ this.props.data }
              moment={ this.props.moment }
              teamCalendar={ this.props.teamCalendar }
              onMomentChange={ this.props.onMomentChange }
              onRangeChange={ this.props.onRangeChange }
            />
          </TeamLeaveTop>
        }
      </Wrapper>
    )
  }
}

const TeamLeaveTop = styled.div`
  flex: 0 0 auto;
  height: 40px;
  display: flex;
  align-items: center;
`
const Wrapper = styled.div`
  background-color: #ffffff ;
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`
const SearchField = styled.input`
  height: 30px;
  padding-left: 30px;
  background: url(${SearchIcon}) no-repeat scroll 10px;
  background-size: 15px 15px;
  font-family: ${FONTS.GOTHAM} !important;
  font-size: ${FONTS.SMALL_SIZE};
  border: 1px solid #ccc;
  border-radius: 4px;
  margin-left: 20px;
  -o-text-overflow: ellipsis;
  -ms-text-overflow: ellipsis;
  text-overflow: ellipsis;
  ::placeholder {
    color: #CCCCCC;
    font-size: 12px;
  }
`
const NavbarTab = styled(Nav)`
  border: none;
  padding-top: 10px;
  font-size: ${FONTS.SMALL_SIZE};
  font-family: ${FONTS.GOTHAM_MEDIUM};
`
const NavLinkTab = styled(NavLink)`
  height: 40px;
  padding-bottom: 20px;
  cursor: pointer;
  &:hover{
    border: none ;
  }
`



// WEBPACK FOOTER //
// ./src/components/searchbar-team-calendar/index.js